"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var styled_components_1 = __importDefault(require("styled-components"));

exports.ParagraphWithColor = styled_components_1.default(components_lib_1.Paragraph)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: 16px;\n    line-height: 1.1;\n    color: ", ";\n    font-weight: bold;\n    margin: 0px 0px 16px 0px;\n"], ["\n    font-size: 16px;\n    line-height: 1.1;\n    color: ", ";\n    font-weight: bold;\n    margin: 0px 0px 16px 0px;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.gray;
});
var templateObject_1;